export const PaymentMethodTypes = {
  nfcMobile: 'nfc_mobile_available',
  americanExpress: 'americanExpressAvailable',
  dinersClub: 'dinersClubAvailable',
  discover: 'discoverAvailable',
  jcb: 'jcbAvailable',
  mastercard: 'mastercardAvailable',
  visa: 'visaAvailable',
  unionPay: 'unionPayAvailable',
  debitCard: 'debitCardAvailable',
  check: 'checkAvailable',
  cashOnly: 'cashOnly',
}

export const creditCardTypes =  ['visaAvailable', 'mastercardAvailable', 'jcbAvailable', 'americanExpressAvailable', 'dinersClubAvailable', 'discoverAvailable', 'unionPayAvailable'] as const
export const otherPaymentTypes =  ['cashOnly', 'debitCardAvailable', 'checkAvailable'] as const
export const electronicMoneyTypes = ['idElectronicMoney','rakutenEdy', 'quicPay', 'waon', 'nanaco', 'auWallet', 'applePay'] as const
export const transportationElectronicMoneyTypes =  ['suica', 'pasmo', 'icoca', 'pitapa', 'sugoca', 'hayakaken', 'toica', 'manaca', 'kitaca', 'sapica', 'nimoca'] as const
export const qrCodePaymentTypes =  ['paypay','dPay', 'auPay', 'rakutenPay', 'weChatPay', 'alipay'] as const

export const PaymentMethodStatuses = ['na', 'ok', 'ng']

// nc === 'no change'
export const BulkEditPaymentMethodStatuses = [ 'nc', ...PaymentMethodStatuses ]
